import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Content, ContentText, ActionButton } from "./styles";
import DialogActions from "../../../DialogActions/DialogActions";
import DialogTitle from "../../../DialogTitle/DialogTitle";

interface Props {
  handleRemove: (index: number) => void;
  index: number;
}

const ConfirmationRemoveItemDialog = ({ handleRemove, index }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.confirmation_remove_item_dialog"; // tRP - translation root path
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleRemoveItem = () => {
    handleRemove(index);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ActionButton
        onClick={() => setOpen(true)}
        style={{ color: theme.palette.error.main }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </ActionButton>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle
          title={t(`${tRP}.title`)}
          handleClose={handleClose}
        />
        <Content>
          <ContentText>{`${t(`${tRP}.message`)}`}</ContentText>
        </Content>
        <DialogActions
          handleCancel={handleClose}
          useGoback
        >
          <Button
            onClick={handleRemoveItem}
            variant="contained"
            color="error"
          >
            {`${t(`${tRP}.remove`)}`}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmationRemoveItemDialog;
